
  <div class="incidence_top" >

    <div class="filter_search">
      <div class="type">
        <form [formGroup]="spillForm">
          <mat-radio-group id="id_number" formGroupName="IncidentTypeStatus">
            <mat-radio-button (change)="onChangeNotificationNoGenerator($event.value)" [checked]="incidentType === 'OilSpill'" value="OilSpill" style="margin-right: 10px;" >
              Oil Spill</mat-radio-button>
         <mat-radio-button (change)="onChangeNotificationNoGenerator($event.value)" [checked]="incidentType === 'NonOilSpill'" value="NonOilSpill">
          Non Oil Spill</mat-radio-button>
        </mat-radio-group>
        </form>
      </div>
      <div class="search_container">
        <input type="text" #search class="default_input search search_land" placeholder="Search" />
        <em class="ti-search"></em> 
      </div>
      <div class="select"><input type="checkbox" (change)="onViewAll($event.target.checked)" value="ViewAll" /> View All</div>

      <button class="default_secondary-btn Add_new" (click)="createEvent()">Create New<em class="ti-plus"></em> </button>
    </div>
  </div>



<!-- </main> -->

<!-- <div class="container">
  <div class="row">

    <div class="col-md-8" >
      <div>
        <input
          type="text"
          id="nav_search search"
          #search
          placeholder="Search with the Incident Name or Incident Notification No."
          style="width:75%; height:40%"
        />
        <span class="search_icon"
          ><img
            src="assets/images/top_nav/Magnifiction.svg"
            alt=""
            class="magnify"
        /></span>
      </div>


    </div>
    <div class="col-md-2">
      <div style="text-align: right">
        <button class="btn btn-primary" (click)="createEvent()">
          <em class="ti-plus mr-2"></em> Create New
        </button>
      </div>
    </div>
    <div class="col-md-2">View All:: <input type="checkbox" value="View All" (click)="viewListEvent()" /> </div>
  </div>
</div> -->

